<script setup>
import { computed } from "vue";
import { Label } from "@/shared/ui/label";
import { cn } from "@/shared/lib/utils";
import { useFormField } from "./useFormField";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});

const { error, formItemId } = useFormField();

const isError = computed(() => error.value !== undefined);
</script>

<template>
  <Label
    data-slot="form-label"
    :for="formItemId"
    :data-error="isError ? '' : undefined"
    :class="cn('data-[error]:text-destructive', props.class)"
  >
    <slot />
  </Label>
</template>
